<template>
  <v-menu
    v-model="menuOpen"
    :close-on-content-click="false"
    offset-y
    max-width="320"
    min-width="280"
    @input="onMenuToggle"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        outlined
        v-bind="attrs"
        v-on="on"
        class="filter-btn"
        :class="{ 'has-filters': hasActiveFilters }"
      >
        <v-icon small left>mdi-filter-variant</v-icon>
        APT Groups
        <span v-if="localAptGroups.length > 0" class="filter-count">
          {{ localAptGroups.length }}
        </span>
      </v-btn>
    </template>

    <v-card class="filters-card">
      <div class="filters-header">
        <span class="filters-title">Filter by APT Group</span>
        <v-btn
          x-small
          text
          color="grey"
          :disabled="localAptGroups.length === 0"
          @click="clearFilters"
        >
          Clear
        </v-btn>
      </div>

      <v-divider />

      <div class="filters-body">
        <div class="apt-list">
          <div
            v-for="group in aptGroupsList"
            :key="group"
            class="apt-item"
            :class="{ 'selected': localAptGroups.includes(group) }"
            @click="toggleGroup(group)"
          >
            <v-icon small class="apt-item__check">
              {{ localAptGroups.includes(group) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
            </v-icon>
            <span class="apt-item__name">{{ group }}</span>
          </div>
          <div v-if="aptGroupsList.length === 0" class="no-groups">
            No APT groups available
          </div>
        </div>
      </div>

      <v-divider />

      <div class="filters-footer">
        <v-btn small text @click="menuOpen = false">Cancel</v-btn>
        <v-btn small color="primary" depressed @click="applyFilters">
          Apply
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'CVEFiltersMenu',
  props: {
    value: {
      type: Object,
      default: () => ({
        aptGroups: [],
      }),
    },
    aptGroupsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      menuOpen: false,
      localAptGroups: [],
    };
  },
  computed: {
    hasActiveFilters() {
      return this.value.aptGroups && this.value.aptGroups.length > 0;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.syncFromValue(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    syncFromValue(val) {
      this.localAptGroups = [...(val.aptGroups || [])];
    },
    onMenuToggle(isOpen) {
      if (isOpen) {
        this.syncFromValue(this.value);
      }
    },
    toggleGroup(group) {
      const idx = this.localAptGroups.indexOf(group);
      if (idx > -1) {
        this.localAptGroups.splice(idx, 1);
      } else {
        this.localAptGroups.push(group);
      }
    },
    clearFilters() {
      this.localAptGroups = [];
    },
    applyFilters() {
      this.$emit('input', {
        aptGroups: [...this.localAptGroups],
      });
      this.menuOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-btn {
  border-color: rgba(0, 0, 0, 0.12) !important;
  text-transform: none !important;
  font-weight: 500;
  letter-spacing: 0 !important;

  &.has-filters {
    border-color: #1976d2 !important;
    color: #1976d2 !important;
  }
}

.filter-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 5px;
  background: #1976d2;
  color: #fff;
  border-radius: 9px;
  font-size: 11px;
  font-weight: 600;
}

.filters-card {
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

.filters-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f5f5f5;
}

.filters-title {
  font-size: 14px;
  font-weight: 600;
  color: #212121;
}

.filters-body {
  padding: 8px 0;
  max-height: 300px;
  overflow-y: auto;
}

.apt-list {
  display: flex;
  flex-direction: column;
}

.apt-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #f5f5f5;
  }

  &.selected {
    background: #e3f2fd;

    .apt-item__check {
      color: #1976d2;
    }

    .apt-item__name {
      color: #1976d2;
      font-weight: 500;
    }
  }
}

.apt-item__check {
  margin-right: 10px;
  color: #9e9e9e;
}

.apt-item__name {
  font-size: 13px;
  color: #424242;
}

.no-groups {
  padding: 20px 16px;
  text-align: center;
  color: #9e9e9e;
  font-size: 13px;
}

.filters-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  background: #f5f5f5;
}
</style>
